// Import Packages
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState, useRecoilValue } from "recoil";

// Import Material UI
//import SaveIcon from "@material-ui/icons/Save";
import StopIcon from '@material-ui/icons/Stop';
import BugReportIcon from "@material-ui/icons/BugReport";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import CreateIcon from "@material-ui/icons/Create";
import PublishRoundedIcon from "@material-ui/icons/PublishRounded";
import StorageIcon from "@material-ui/icons/Storage";
import CircularProgress from '@material-ui/core/CircularProgress';
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core";

// Import Pages
import Info from "../../../autom/editAction/components/Info";
import { alertState, licensePermission } from "../../../../../../recoil-store/recoil-state";

// Import Services
import TriggerService from "../../../../../../services/triggerService/triggerService";
import AutomService from "../../../../../../services/AutomService/AutomService";

// Import Icons
import triggerIcon from "../../../../../../assets/icons/Trigger.png";

import ResetIcon from '../../../../../../assets/icons/headerIcons/reset-icon.svg';
import DataStoreIcon from '../../../../../../assets/icons/headerIcons/data-store-icon.svg';
import EditIcon from '../../../../../../assets/icons/headerIcons/edit-icon.svg';
import PlayIcon from '../../../../../../assets/icons/headerIcons/play-icon.svg';
import SaveIcon from '../../../../../../assets/icons/headerIcons/save-icon.svg';
import PublishIcon from '../../../../../../assets/icons/headerIcons/publish-icon.svg';

// Import CSS
import "./Header.css";











const useStopStyle = makeStyles((theme) => ({
    stop: {
        left: 2,
        color: "rgb(215, 94, 94)",
        position: "absolute",
        width: 19,
        top: 0,
        zIndex: 9,
        cursor: "pointer"
    }
}));

const StyledMenu = withStyles({
    paper: {
        border: "1px solid #d3d4d5",
    }
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "center",
        }}
        {...props}
    />
));

const Header = ({
    automDetail,
    operationId,
    resetFlow,
    saveFlow,
    runFlow,
    debugFlow,
    editFlow,
    openDebugRunning,
    setOpenDebugRunning,
    setTriggerModal,
    setOpenSchedule,
    handleStop,
    handleStart,
    trigger,
    isRunning,
    triggerType,
    setOpenDrive,
    publishFlow,
    debuggingStart,
    setFlowStatus,
    testAppStarted,
    handleTestAppCancel
}) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const setAlert = useSetRecoilState(alertState);
    const license = useRecoilValue(licensePermission);
    const [customLibraryDevelopment, setCustomLibraryDevelopment] = useState(false);

    useEffect(() => {
        if (license.data.add_ons && license.data.add_ons.find(x => x === 'CustomLibraryDevelopment')) {
            setCustomLibraryDevelopment(true);
        }
    }, [])

    const handleEmailTriggerMenu = (event) => {
        if (trigger) {
            setAnchorEl(event.currentTarget);
        }
    };
    const handleClose = () => {
        if (trigger) {
            setAnchorEl(null);
        }
    };

    async function handleCancel() {
        setAlert(alert => ({
            ...alert,
            show: true,
            message: t("MESSAGES.AUTOMS.DEBUG-PROCESS-CANCELING"),
            severity: "info"
        }))
        const resp = await AutomService.cancelAutom({ operationId: operationId, mate_id: automDetail.mate_id });
        if (resp) {
            if (resp?.status) {
                //setIsCanceled(true);
                setFlowStatus(3);
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.AUTOMS.DEBUG-PROCESS-CANCELED"),
                    severity: "success"
                }))
                setOpenDebugRunning(false);
            }
        }
    }

    async function handleCancelTestApp() {
        setAlert(alert => ({
            ...alert,
            show: true,
            message: t("MESSAGES.AUTOMS.TEST-APP-PROCESS-CANCELING"),
            severity: "info"
        }))
        handleTestAppCancel(false);
    }

    const classes = useStopStyle();
    return (
        <div className="new-flow-header">
            <div style={{ display: "flex", alignItems: "center" }}>
                <button onClick={() => debugFlow()} disabled={openDebugRunning}>
                    <Info value={t("CONTENT.FLOW.DEBUG")} placement="bottom">
                        <BugReportIcon style={{ color: debuggingStart ? "#d75e5e" : "#8F94A6", padding: 2 }} />
                    </Info>
                </button>
                <Info value={automDetail.name} placement="bottom">
                    <span className='content-overflow' style={{ maxWidth: 200 }}>
                        {automDetail.name}
                    </span>
                </Info>
                {automDetail?.integration_type === "TRIGGER" ? (
                    <Info value={t("CONTENT.FLOW.TRIGGER")} placement="bottom">
                        <div className="webhook-icon" onClick={() => setTriggerModal(true)}>
                            <img
                                className="right-side button"
                                src={triggerIcon}
                                alt="autommate"
                            />
                        </div>
                    </Info>
                ) : null}
                {automDetail?.integration_type === "SCHEDULE" && !automDetail?.trigger_type.includes("app") ? (
                    <Info value={t("CONTENT.FLOW.SCHEDULE")} placement="bottom">
                        <div className="webhook-icon">
                            <img
                                alt="autommate"
                                className="right-side button"
                                style={{ opacity: 0.3 }}
                                onClick={() => setOpenSchedule(true)}
                                src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGlkPSJDYXBhXzEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU5Ljk5IDU5Ljk5OyIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgNTkuOTkgNTkuOTkiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnPjxwYXRoIGQ9Ik0xLjAwNSwzMWMwLjU1MiwwLDEtMC40NDcsMS0xYzAtMTUuNDM5LDEyLjU2MS0yOCwyOC0yOGM2LjMyNywwLDEyLjM3OCwyLjExNSwxNy4zMDIsNmgtNS4zMDJjLTAuNTUyLDAtMSwwLjQ0Ny0xLDEgICBzMC40NDgsMSwxLDFoNy45MTVjMC4wNjYsMC4wMDYsMC4xMjgsMC4wMDcsMC4xOTMsMGgwLjg5MVYxYzAtMC41NTMtMC40NDgtMS0xLTFzLTEsMC40NDctMSwxdjUuODEgICBDNDMuNjQ4LDIuNDA4LDM2Ljk4NiwwLDMwLjAwNSwwYy0xNi41NDIsMC0zMCwxMy40NTgtMzAsMzBDMC4wMDUsMzAuNTUzLDAuNDUzLDMxLDEuMDA1LDMxeiIvPjxwYXRoIGQ9Ik0zMC4wMDUsOGMtMTIuMTMxLDAtMjIsOS44NjktMjIsMjJzOS44NjksMjIsMjIsMjJzMjItOS44NjksMjItMjJTNDIuMTM2LDgsMzAuMDA1LDh6IE0zMC4wMDUsNTAgICBjLTExLjAyOCwwLTIwLTguOTcyLTIwLTIwczguOTcyLTIwLDIwLTIwczIwLDguOTcyLDIwLDIwUzQxLjAzMyw1MCwzMC4wMDUsNTB6Ii8+PHBhdGggZD0iTTMwLjAwNSwxNWMwLjU1MiwwLDEtMC40NDcsMS0xdi0yYzAtMC41NTMtMC40NDgtMS0xLTFzLTEsMC40NDctMSwxdjJDMjkuMDA1LDE0LjU1MywyOS40NTMsMTUsMzAuMDA1LDE1eiIvPjxwYXRoIGQ9Ik0zMC4wMDUsNDVjLTAuNTUyLDAtMSwwLjQ0Ny0xLDF2MmMwLDAuNTUzLDAuNDQ4LDEsMSwxczEtMC40NDcsMS0xdi0yQzMxLjAwNSw0NS40NDcsMzAuNTU3LDQ1LDMwLjAwNSw0NXoiLz48cGF0aCBkPSJNNDYuMDA1LDMxaDJjMC41NTIsMCwxLTAuNDQ3LDEtMXMtMC40NDgtMS0xLTFoLTJjLTAuNTUyLDAtMSwwLjQ0Ny0xLDFTNDUuNDUzLDMxLDQ2LjAwNSwzMXoiLz48cGF0aCBkPSJNMTQuMDA1LDI5aC0yYy0wLjU1MiwwLTEsMC40NDctMSwxczAuNDQ4LDEsMSwxaDJjMC41NTIsMCwxLTAuNDQ3LDEtMVMxNC41NTcsMjksMTQuMDA1LDI5eiIvPjxwYXRoIGQ9Ik0zMS4wMDUsMjUuMTQyVjIwYzAtMC41NTMtMC40NDgtMS0xLTFzLTEsMC40NDctMSwxdjUuMTQyYy0xLjcyLDAuNDQ3LTMsMS45OTktMywzLjg1OGMwLDAuNzQsMC4yMTUsMS40MjQsMC41NjcsMi4wMTkgICBsLTguMjc0LDguMjc0Yy0wLjM5MSwwLjM5MS0wLjM5MSwxLjAyMywwLDEuNDE0QzE4LjQ5Myw0MC45MDIsMTguNzQ5LDQxLDE5LjAwNSw0MXMwLjUxMi0wLjA5OCwwLjcwNy0wLjI5M2w4LjI3NC04LjI3NCAgIEMyOC41ODEsMzIuNzg1LDI5LjI2NSwzMywzMC4wMDUsMzNjMi4yMDYsMCw0LTEuNzk0LDQtNEMzNC4wMDUsMjcuMTQxLDMyLjcyNSwyNS41ODksMzEuMDA1LDI1LjE0MnogTTMwLjAwNSwzMSAgIGMtMS4xMDMsMC0yLTAuODk3LTItMnMwLjg5Ny0yLDItMnMyLDAuODk3LDIsMlMzMS4xMDgsMzEsMzAuMDA1LDMxeiIvPjxwYXRoIGQ9Ik0xMS44OTQsNTIuNjZjLTAuMzMsMC40MzktMC4yNCwxLjA2OSwwLjIxLDEuMzk5YzAuMTcsMC4xMywwLjM4LDAuMTksMC41OSwwLjE5YzAuMzEsMCwwLjYxLTAuMTMsMC44MS0wLjQgICBjMC4zMi0wLjQzOSwwLjIzLTEuMDY5LTAuMjEtMS4zOTlDMTIuODU0LDUyLjEyLDEyLjIyNSw1Mi4yMSwxMS44OTQsNTIuNjZ6Ii8+PHBhdGggZD0iTTcuMjM1LDQ2LjI3Yy0wLjMyLTAuNDM5LTAuOTUtMC41NS0xLjQtMC4yMjljLTAuNDUsMC4zMy0wLjU1LDAuOTUtMC4yMywxLjM5OWMwLjIsMC4yNzEsMC41LDAuNDIsMC44MiwwLjQyICAgYzAuMiwwLDAuNC0wLjA2LDAuNTgtMC4xODlDNy40NTQsNDcuMzUsNy41NTUsNDYuNzIsNy4yMzUsNDYuMjd6Ii8+PHBhdGggZD0iTTcuNjI0LDQ4LjQ1Yy0wLjQxLDAuMzY5LTAuNDUsMS0wLjA4LDEuNDA5YzAuMTksMC4yMywwLjQ3LDAuMzQxLDAuNzUsMC4zNDFjMC4yMywwLDAuNDctMC4wOCwwLjY2LTAuMjUgICBjMC40MS0wLjM3LDAuNDUtMSwwLjA4LTEuNDFDOC42NzUsNDguMTIsOC4wNDUsNDguMDksNy42MjQsNDguNDV6Ii8+PHBhdGggZD0iTTExLjA2NSw1MC42Yy0wLjQtMC4zNy0xLjA0LTAuMzQtMS40MSwwLjA2MWMtMC4zOCwwLjQwOS0wLjM1LDEuMDQsMC4wNiwxLjQyYzAuMTksMC4xNywwLjQzLDAuMjYsMC42NywwLjI2ICAgYzAuMjcsMCwwLjU0LTAuMTEsMC43NC0wLjMyYzAuMzctMC40MSwwLjM1LTEuMDQtMC4wNi0xLjQxQzExLjA2NSw1MC42LDExLjA2NSw1MC42LDExLjA2NSw1MC42eiIvPjxwYXRoIGQ9Ik01LjY3NSw0My44NGMtMC4wMSwwLTAuMDEsMC0wLjAxLDBjLTAuMjctMC40OC0wLjg4LTAuNjUtMS4zNi0wLjM3Yy0wLjQ4LDAuMjcxLTAuNjUsMC44OC0wLjM3LDEuMzYgICBjMC4xOCwwLjMxOSwwLjUyLDAuNSwwLjg3LDAuNWMwLjE2LDAsMC4zNC0wLjA0LDAuNDktMC4xM0M1Ljc3NSw0NC45Myw1Ljk0NSw0NC4zMTksNS42NzUsNDMuODR6Ii8+PHBhdGggZD0iTTU4Ljk0NSwzMi4xMmMwLjAyLDAsMC4wMywwLDAuMDQsMGMwLjU0LDAsMC45OC0wLjQzMSwxLTAuOTZjMC4wMi0wLjU2MS0wLjQxLTEuMDIxLTAuOTYtMS4wNCAgIGMtMC41NS0wLjAyMS0xLjAyLDAuNDEtMS4wNCwwLjk2UzU4LjM5NCwzMi4xLDU4Ljk0NSwzMi4xMnoiLz48cGF0aCBkPSJNMS4yNjUsMzMuOTljMC41NS0wLjA2MSwwLjk1LTAuNTUxLDAuODktMS4xMDFzLTAuNTUtMC45NS0xLjEtMC44OWMtMC41NSwwLjA1LTAuOTUsMC41NS0wLjg5LDEuMDkgICBjMC4wNSwwLjUyLDAuNDksMC45LDAuOTksMC45QzEuMTk1LDMzLjk5LDEuMjI1LDMzLjk5LDEuMjY1LDMzLjk5eiIvPjxwYXRoIGQ9Ik0xLjgyNSwzNi45M2MwLjU0LTAuMTEsMC44OS0wLjY0LDAuNzctMS4xOGMtMC4xMS0wLjU0LTAuNjQtMC44OTEtMS4xOC0wLjc3MWMtMC41NCwwLjExLTAuODksMC42NDEtMC43NywxLjE4MSAgIGMwLjA5LDAuNDcsMC41MSwwLjc5LDAuOTcsMC43OUMxLjY4NCwzNi45NSwxLjc1NSwzNi45NSwxLjgyNSwzNi45M3oiLz48cGF0aCBkPSJNNC4zNjUsNDEuMjVjLTAuMjItMC41LTAuODEtMC43My0xLjMyLTAuNTFjLTAuNSwwLjIyLTAuNzMsMC44MS0wLjUxLDEuMzE5YzAuMTcsMC4zNywwLjUzLDAuNjAxLDAuOTIsMC42MDEgICBjMC4xMywwLDAuMjctMC4wMywwLjQtMC4wOTFDNC4zNTQsNDIuMzUsNC41ODQsNDEuNzYsNC4zNjUsNDEuMjV6Ii8+PHBhdGggZD0iTTMuMzM0LDM4LjU1Yy0wLjE2LTAuNTMtMC43My0wLjgyLTEuMjUtMC42NWMtMC41MywwLjE3LTAuODIsMC43My0wLjY1LDEuMjYxYzAuMTQsMC40MiwwLjUzLDAuNjg5LDAuOTUsMC42ODkgICBjMC4xLDAsMC4yMS0wLjAxLDAuMzEtMC4wNEMzLjIxNSwzOS42NCwzLjUwNSwzOS4wNjksMy4zMzQsMzguNTV6Ii8+PHBhdGggZD0iTTI5LjQ2NSw1Ny45OWMtMC41NS0wLjAxMS0xLjAxLDAuNDMtMS4wMiwwLjk3OWMtMC4wMSwwLjU2MSwwLjQzLDEuMDEsMC45OCwxLjAyMWMwLjAxLDAsMC4wMiwwLDAuMDIsMCAgIGMwLjU1LDAsMC45OS0wLjQzMSwxLTAuOThDMzAuNDU0LDU4LjQ2LDMwLjAxNSw1OCwyOS40NjUsNTcuOTl6Ii8+PHBhdGggZD0iTTUyLjEzNSw0Ny4xNGMtMC4zNCwwLjQzLTAuMjYsMS4wNjEsMC4xNywxLjRjMC4xOSwwLjE0LDAuNCwwLjIxLDAuNjIsMC4yMWMwLjI5LDAsMC41OS0wLjEzLDAuNzktMC4zOTEgICBjMC4zNC0wLjQzLDAuMjYtMS4wNi0wLjE4LTEuMzk5UzUyLjQ3NSw0Ni43LDUyLjEzNSw0Ny4xNHoiLz48cGF0aCBkPSJNNDUuODM0LDUzLjA4Yy0wLjQ1LDAuMzEtMC41NywwLjkzOS0wLjI1LDEuMzljMC4xOSwwLjI4LDAuNSwwLjQzLDAuODIsMC40M2MwLjIsMCwwLjM5LTAuMDUsMC41Ny0wLjE3ICAgYzAuNDUtMC4zMSwwLjU3LTAuOTM5LDAuMjUtMS4zOUM0Ni45MTQsNTIuODgsNDYuMjk1LDUyLjc3LDQ1LjgzNCw1My4wOHoiLz48cGF0aCBkPSJNNDguMTM1LDUxLjMxOWMtMC40MiwwLjM2LTAuNDcsMC45OS0wLjExLDEuNDFjMC4yLDAuMjMsMC40OCwwLjM1MSwwLjc2LDAuMzUxYzAuMjMsMCwwLjQ2LTAuMDgsMC42NS0wLjI0ICAgYzAuNDItMC4zNiwwLjQ3LTAuOTksMC4xMS0xLjQxQzQ5LjE4NCw1MS4wMSw0OC41NTUsNTAuOTYsNDguMTM1LDUxLjMxOXoiLz48cGF0aCBkPSJNNTUuMTY0LDQ0LjQzOWMtMC40Ny0wLjI5LTEuMDktMC4xNC0xLjM4LDAuMzJjLTAuMjksMC40Ny0wLjE1LDEuMDksMC4zMiwxLjM4YzAuMTcsMC4xMDEsMC4zNSwwLjE1LDAuNTMsMC4xNSAgIGMwLjMzLDAsMC42Ni0wLjE2LDAuODUtMC40NzFDNTUuNzc1LDQ1LjM1LDU1LjYzNSw0NC43MjksNTUuMTY0LDQ0LjQzOXoiLz48cGF0aCBkPSJNNTAuMjQ1LDQ5LjMzYy0wLjM5LDAuMzk5LTAuMzcsMS4wMjksMC4wMywxLjQxYzAuMTksMC4xODksMC40NCwwLjI3OSwwLjY5LDAuMjc5YzAuMjYsMCwwLjUzLTAuMSwwLjcyLTAuMzEgICBjMC4zOC0wLjQsMC4zNy0xLjAzLTAuMDMtMS40MVM1MC42MjQsNDguOTMsNTAuMjQ1LDQ5LjMzeiIvPjxwYXRoIGQ9Ik01OC44NTQsMzMuMTA5Yy0wLjU0LTAuMDc5LTEuMDUsMC4zMTEtMS4xMywwLjg1MWMtMC4wOCwwLjU1LDAuMywxLjA1LDAuODUsMS4xM2MwLjA1LDAuMDEsMC4xLDAuMDEsMC4xNCwwLjAxICAgYzAuNDksMCwwLjkyLTAuMzU5LDAuOTktMC44NTlDNTkuNzg1LDMzLjcsNTkuNDA1LDMzLjE4OSw1OC44NTQsMzMuMTA5eiIvPjxwYXRoIGQ9Ik01OC4zODUsMzYuMDY5Yy0wLjU0LTAuMTMtMS4wOCwwLjItMS4yMiwwLjczYy0wLjEzLDAuNTQsMC4yLDEuMDgsMC43MywxLjIyYzAuMDgsMC4wMjEsMC4xNiwwLjAzLDAuMjQsMC4wMyAgIGMwLjQ1LDAsMC44Ni0wLjMxLDAuOTctMC43NkM1OS4yNDUsMzYuNzUsNTguOTE0LDM2LjIxLDU4LjM4NSwzNi4wNjl6Ii8+PHBhdGggZD0iTTE1LjcwNCw1NC4wNmMtMC40OC0wLjI3OS0xLjA5LTAuMTMtMS4zNywwLjM1MWMtMC4yOSwwLjQ3LTAuMTMsMS4wOSwwLjM0LDEuMzdjMC4xNiwwLjEsMC4zNCwwLjE0LDAuNTEsMC4xNCAgIGMwLjM0LDAsMC42Ny0wLjE3LDAuODYtMC40OUMxNi4zMzQsNTQuOTYsMTYuMTc1LDU0LjM1LDE1LjcwNCw1NC4wNnoiLz48cGF0aCBkPSJNNTcuNjA0LDM4Ljk3Yy0wLjUyLTAuMTg5LTEuMSwwLjA4LTEuMjgsMC42Yy0wLjE5LDAuNTIxLDAuMDcsMS4wOTEsMC41OSwxLjI4YzAuMTEsMC4wNCwwLjIzLDAuMDYxLDAuMzQsMC4wNjEgICBjMC40MSwwLDAuOC0wLjI1LDAuOTQtMC42NkM1OC4zODUsMzkuNzI5LDU4LjEyNCwzOS4xNiw1Ny42MDQsMzguOTd6Ii8+PHBhdGggZD0iTTU2LjUyNSw0MS43N2MtMC40OS0wLjIzOS0xLjEtMC4wNC0xLjM0LDAuNDZjLTAuMjQsMC41LTAuMDMsMS4xMDEsMC40NiwxLjM0YzAuMTQsMC4wNywwLjI5LDAuMTAxLDAuNDQsMC4xMDEgICBjMC4zNywwLDAuNzMtMC4yMSwwLjktMC41NjFDNTcuMjI1LDQyLjYwOSw1Ny4wMjUsNDIuMDEsNTYuNTI1LDQxLjc3eiIvPjxwYXRoIGQ9Ik0yNi41NzUsNTcuNzljLTAuNTUtMC4wNy0xLjA0LDAuMzE5LTEuMTEsMC44N2MtMC4wNywwLjU1LDAuMzIsMS4wNSwwLjg3LDEuMTA5djAuMDExYzAuMDQsMCwwLjA4LDAsMC4xMiwwICAgYzAuNSwwLDAuOTMtMC4zNywwLjk5LTAuODgxQzI3LjUxNSw1OC4zNSwyNy4xMjQsNTcuODU5LDI2LjU3NSw1Ny43OXoiLz48cGF0aCBkPSJNMjAuOTQ1LDU2LjVjLTAuNTItMC4xODEtMS4wOSwwLjA5LTEuMjcsMC42MmMtMC4xOCwwLjUyLDAuMSwxLjA5LDAuNjIsMS4yN2MwLjExLDAuMDMsMC4yMiwwLjA1LDAuMzMsMC4wNSAgIGMwLjQxLDAsMC44LTAuMjYsMC45NC0wLjY3QzIxLjc0NSw1Ny4yNCwyMS40NjUsNTYuNjcsMjAuOTQ1LDU2LjV6Ii8+PHBhdGggZD0iTTIzLjcyNSw1Ny4yOWMtMC41NC0wLjEyLTEuMDcsMC4yMS0xLjIsMC43NWMtMC4xMiwwLjU0LDAuMjIsMS4wOCwwLjc1LDEuMmMwLjA4LDAuMDIsMC4xNSwwLjAyLDAuMjMsMC4wMiAgIGMwLjQ1LDAsMC44Ny0wLjMxLDAuOTctMC43N0MyNC42MDQsNTcuOTUsMjQuMjY1LDU3LjQxLDIzLjcyNSw1Ny4yOXoiLz48cGF0aCBkPSJNMTguMjY1LDU1LjQyYy0wLjUxLTAuMjQtMS4xLTAuMDIxLTEuMzMsMC40NzlzLTAuMDIsMS4xMDEsMC40OCwxLjMzYzAuMTQsMC4wNjEsMC4yOCwwLjA5LDAuNDIsMC4wOSAgIGMwLjM4LDAsMC43NC0wLjIxLDAuOTEtMC41NzlDMTguOTc1LDU2LjI0LDE4Ljc2NSw1NS42NDksMTguMjY1LDU1LjQyeiIvPjxwYXRoIGQ9Ik0zNS4yMjUsNTcuNTFjLTAuNTQsMC4xLTAuOSwwLjYzLTAuOCwxLjE3YzAuMDksMC40OCwwLjUyLDAuODExLDAuOTksMC44MTFjMC4wNiwwLDAuMTIsMCwwLjE4LTAuMDExICAgYzAuNTQtMC4xMDksMC45LTAuNjMsMC44LTEuMTdDMzYuMjk1LDU3Ljc2LDM1Ljc2NSw1Ny40MSwzNS4yMjUsNTcuNTF6Ii8+PHBhdGggZD0iTTM4LjAzNSw1Ni44M2MtMC41MywwLjE0OS0wLjgzLDAuNzEtMC42NywxLjIzOWMwLjEzLDAuNDMxLDAuNTMsMC43MTEsMC45NiwwLjcxMWMwLjA5LDAsMC4xOS0wLjAxMSwwLjI5LTAuMDQgICBjMC41My0wLjE2LDAuODMtMC43MjEsMC42Ny0xLjI1QzM5LjEyNCw1Ni45NywzOC41NjUsNTYuNjcsMzguMDM1LDU2LjgzeiIvPjxwYXRoIGQ9Ik00MC43NjUsNTUuODVjLTAuNTEsMC4yMS0wLjc1LDAuOC0wLjU0LDEuMzExYzAuMTYsMC4zOCwwLjUzLDAuNjA5LDAuOTIsMC42MDljMC4xMywwLDAuMjYtMC4wMiwwLjM5LTAuMDY5ICAgYzAuNTEtMC4yMjEsMC43NS0wLjgwMSwwLjU0LTEuMzExQzQxLjg1NCw1NS44OCw0MS4yNzUsNTUuNjQsNDAuNzY1LDU1Ljg1eiIvPjxwYXRoIGQ9Ik0zMi4zNTQsNTcuODk5Yy0wLjU1LDAuMDUxLTAuOTYsMC41My0wLjkxLDEuMDhjMC4wNCwwLjUyMSwwLjQ4LDAuOTIsMSwwLjkyYzAuMDIsMCwwLjA1LDAsMC4wOCwwdi0wLjAxICAgYzAuNTUtMC4wNCwwLjk2LTAuNTIsMC45MS0xLjA3QzMzLjM5NCw1OC4yNywzMi45MDUsNTcuODU5LDMyLjM1NCw1Ny44OTl6Ii8+PHBhdGggZD0iTTQzLjM3NCw1NC42Yy0wLjQ5LDAuMjYtMC42NywwLjg3LTAuNCwxLjM1MWMwLjE4LDAuMzQsMC41MiwwLjUyOSwwLjg4LDAuNTI5YzAuMTYsMCwwLjMyLTAuMDQsMC40Ny0wLjEzICAgYzAuNDktMC4yNiwwLjY3LTAuODcsMC40LTEuMzVDNDQuNDY1LDU0LjUxLDQzLjg1NCw1NC4zMyw0My4zNzQsNTQuNnoiLz48L2c+PGcvPjxnLz48Zy8+PGcvPjxnLz48Zy8+PGcvPjxnLz48Zy8+PGcvPjxnLz48Zy8+PGcvPjxnLz48Zy8+PC9zdmc+"
                            />
                        </div>
                    </Info>
                ) : null}
            </div>
            <div className="new-flow-header-buttons">
                <button onClick={() => resetFlow()}>
                    <Info value={t("CONTENT.FLOW.RESET")} placement="bottom">
                        <img src={ResetIcon} alt="" />
                    </Info>
                </button>
                <div className="tabs-seperator" />
                <button onClick={() => setOpenDrive(true)}>
                    <Info value="Data Store" placement="bottom">
                        <img src={DataStoreIcon} alt="" />
                    </Info>
                </button>
                <div className="tabs-seperator" />
                <button onClick={() => editFlow()}>
                    <Info value={t("CONTENT.FLOW.EDIT")} placement="bottom">
                        <img src={EditIcon} alt="" />
                    </Info>
                </button>
                <div className="tabs-seperator" />
                <div>

                    {openDebugRunning ? (
                        <div style={{ position: "relative" }}>
                            <Info value={t("CONTENT.FLOW.STOP")} placement="bottom">
                                <StopIcon className={classes.stop} onClick={handleCancel} />
                            </Info>
                            <CircularProgress size={24} />
                        </div>
                    ) : (
                        <button
                            style={{ cursor: "pointer" }}
                            aria-controls="email-trigger-menu"
                            aria-haspopup="true"
                            onClick={() => runFlow()}
                            onMouseEnter={(e) => handleEmailTriggerMenu(e)}
                        >
                            <Info value={t("CONTENT.FLOW.RUN")} placement="bottom">
                                <img src={PlayIcon} alt="" />
                            </Info>
                        </button>
                    )}

                    <StyledMenu
                        style={{ marginTop: 2 }}
                        id="email-trigger-menu"
                        onMouseLeave={() => setAnchorEl(null)}
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        MenuListProps={{ onMouseLeave: handleClose }}
                    >
                        <MenuItem
                            style={{ fontSize: 11, fontWeight: "600" }}
                            onClick={runFlow}
                        >
                            {t("CONTENT.FLOW.RUN-FLOW")}
                        </MenuItem>
                        {trigger &&
                            (isRunning ? (
                                <MenuItem
                                    style={{ fontSize: 11, fontWeight: "600" }}
                                    onClick={handleStop}
                                >
                                    {t("CONTENT.FLOW.STOP-" + triggerType)}
                                </MenuItem>
                            ) : (
                                <>
                                    {triggerType === "APP-TRIGGER" ? (
                                        <>
                                            <MenuItem
                                                style={{ fontSize: 11, fontWeight: "600" }}
                                                onClick={() => handleStart(true)}
                                            >
                                                {t("CONTENT.FLOW.TEST-" + triggerType)}
                                            </MenuItem>
                                            <MenuItem
                                                style={{ fontSize: 11, fontWeight: "600" }}
                                                onClick={() => handleStart(false)}
                                            >
                                                {t("CONTENT.FLOW.START-" + triggerType)}
                                            </MenuItem>
                                        </>
                                    ) : (
                                        <MenuItem
                                            style={{ fontSize: 11, fontWeight: "600" }}
                                            onClick={() => handleStart(false)}
                                        >
                                            {t("CONTENT.FLOW.START-" + triggerType)}
                                        </MenuItem>
                                    )}

                                </>
                            ))}
                    </StyledMenu>
                </div>

                <div className="tabs-seperator" />
                <button onClick={() => saveFlow()}>
                    <Info value={t("CONTENT.FLOW.SAVE")} placement="bottom">
                        <img src={SaveIcon} alt="" />
                    </Info>
                </button>
                {
                    customLibraryDevelopment && <>
                        <div className="tabs-seperator" />
                        <button onClick={() => publishFlow()} style={{ marginTop: '0px' }}>
                            <Info value={t("CONTENT.FLOW.PUBLISH")} placement="bottom">
                                <div className="publish-container">
                                    <img src={PublishIcon} alt="" className="publish-icon" />
                                    <span className="publish-text font-manrope">
                                        Publish
                                    </span>
                                </div>

                            </Info>
                        </button>
                    </>
                }

            </div>
        </div>
    );
};
export default Header;
